import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Twitter } from 'lucide-react';

const TeamPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const team = [
    { name: 'John Gerber', role: 'Co-Founder & CEO', image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80', bio: 'Tech visionary building scalable e-commerce and marketplace solutions.' },
    { name: 'Rajesh Kumar', role: 'Co-Founder & CTO', image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80', bio: 'Former energy consultant with 15+ years in renewable policy and technology.' }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow pt-24 bg-background">
        <div className="container-solar py-12 md:py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Meet the <span className="solar-text-gradient">Team</span>
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              We are a group of passionate engineers, designers, and solar enthusiasts working together
              to accelerate the global transition to sustainable energy.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: i * 0.1 }}
                className="bg-card rounded-2xl overflow-hidden border border-border shadow-sm group"
              >
                <div className="h-64 overflow-hidden relative">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6 justify-center gap-4">
                    <button className="text-white hover:text-primary transition-colors"><Linkedin className="w-5 h-5" /></button>
                    <button className="text-white hover:text-primary transition-colors"><Twitter className="w-5 h-5" /></button>
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold mb-1">{member.name}</h3>
                  <p className="text-primary font-medium text-sm mb-4">{member.role}</p>
                  <p className="text-muted-foreground text-sm">{member.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default TeamPage;
